export default function WhyChooseUs() {
  const reasons = [
    {
      icon: 'ri-global-line',
      title: 'Specialised for Malaysian & ESL learners',
      description: 'Tailored programs for Malaysian students and ESL learners from Korea, Japan, and China'
    },
    {
      icon: 'ri-home-heart-line',
      title: 'Home-based and Online learning',
      description: 'Warm, focused environment that feels like home. Online class also available for added flexibility.'
    },
    {
      icon: 'ri-group-line',
      title: 'Premium and Standard Group Class Options Available',
      description: 'Flexible class sizes to suit your child\'s learning preferences and needs'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Student Expectation for 90-100% Progression',
      description: 'As the saying goes, "spare the rod and spoil the child." We take classwork and homework seriously. To see improvement, students are expected to complete all homework and participate with focus and seriousness. An agreement we expect parents and students to understand.'
    },
    {
      icon: 'ri-focus-3-line',
      title: 'Discipline, Confidence, and Clarity',
      description: 'Strong emphasis on building healthy learning habits'
    },
    {
      icon: 'ri-heart-3-line',
      title: 'Respect, Responsibility & Integrity',
      description: 'Core values that guide our teaching and learning culture'
    }
  ];

  return (
    <section id="why-choose-us" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-['Yeseva_One',serif] text-4xl md:text-5xl text-[#153223] mb-4">
            Why Parents Choose OHT
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            A trusted partner in your child's English learning journey
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {reasons.map((reason, index) => (
            <div 
              key={index}
              className="bg-[#F5F1E8] p-8 rounded-xl hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-[#FFE66D]"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-[#153223] rounded-full mb-4">
                <i className={`${reason.icon} text-2xl text-[#FFE66D]`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#153223] mb-3">
                {reason.title}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
